import React from 'react';

function About() {
  return (
    <div className="page-container">
      <div className="header-container">About Us</div>
      <div className="text-container">
        At MetroDesign, we are passionate about designing solutions that transform ideas into reality, 
        building projects with precision and expertise, and inspiring success through innovation and collaboration. 
        With years of experience in the construction consulting industry, our team is dedicated to guiding you 
        through every phase of your project. From conceptual planning to final execution, we focus on delivering 
        exceptional results that not only meet but exceed your expectations.
      </div>
    </div>
  );
}

export default About;
